import { useState, useEffect } from 'react';
import { SendMessage } from './App.js';
import icobackblue from './img/ico-backblue.svg';
import playpause from './img/playpause.svg';
import iconextsong from './img/ico-nextsong.svg';
import icoreplay from './img/ico-replay.svg';
import icoclosewhite from './img/ico-closeWhite.svg';
import icopause from './img/ico-pause.svg';
import icodelblue from './img/ico-delBlue.svg';
import icoplay from './img/ico-play.svg';
import icovol from './img/ico-vol.svg';
import strings from './strings.js'
import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = "https://www.starboxkod.com/api";

const SelectingMissingCard = ({ stateVer, onClick, lang}  ) => {

    function handleSubmit() {

        if (missingSongName1 !== "" || missingSingerName1 !== "") {
            axios.post('https://starboxkod.com:8443', postData1)
            .then(response => {
                console.log('Success:', response.data);
            })
            .catch(error => {
                console.error('Error:', error);
            });

        }
        if (missingSongName2 !== "" || missingSingerName2 !== "") {
            axios.post('https://starboxkod.com:8443', postData2)
            .then(response => {
                console.log('Success:', response.data);
            })
            .catch(error => {
                console.error('Error:', error);
            });

        }
        if (missingSongName3 !== "" || missingSingerName3 !== "") {
            axios.post('https://starboxkod.com:8443', postData3)
            .then(response => {
                console.log('Success:', response.data);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }
        if(missingSongName1 !== "" || missingSingerName1 !== ""|| missingSongName2 !== "" || missingSingerName2 !== "" || missingSongName3 !== "" || missingSingerName3 !== "") {
            onClick();
            toast.success(lang?strings.cn.missingSongSuccess:strings.en.missingSongSuccess, {
                position: "top-center",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
                icon: false,
            });
        }

    }


    const [missingSongName1, setMissingSongName1] = useState("");
    const [missingSingerName1, setMissingSingerName1] = useState("");
    const [missingSongName2, setMissingSongName2] = useState("");
    const [missingSingerName2, setMissingSingerName2] = useState("");
    const [missingSongName3, setMissingSongName3] = useState("");
    const [missingSingerName3, setMissingSingerName3] = useState("");

    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
        
    const postData1 = {
      date: formattedDate,
      song: missingSongName1, // Replace with the actual variable containing the song name
      singer: missingSingerName1 // Replace with the actual variable containing the singer name
    };

    const postData2 = {
        date: formattedDate,
        song: missingSongName2, // Replace with the actual variable containing the song name
        singer: missingSingerName2 // Replace with the actual variable containing the singer name
    };

    const postData3 = {
        date: formattedDate,
        song: missingSongName3, // Replace with the actual variable containing the song name
        singer: missingSingerName3 // Replace with the actual variable containing the singer name
    };



    const song = {
        "song_num": 110108,
        "song_name": "给我多一点",
        "singer": "SHE",
        "language": "国语",
        "server_id": "C",
        "rel_path": "05\\110108"
    }
    

    useEffect(() => {
      
    }, []);
  
    return (

    <div className="LMAOselecting">
        <div className="mui-overlay"
        onClick={(e) => {e.preventDefault(); /* onClick() */}}
        ></div>
        

        <div className="actions-sheet2" 
        style={{paddingBottom: "20px", paddingTop: "15px"}}
        onClick={(e) => {e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation();}}>
        <div className="controlCardClose">
            <a className="controlCardCloseIcon" onClick={(e) => {e.preventDefault(); onClick() }}>
            <img 
                src={icoclosewhite}
                alt="close"
            />
            </a>
        </div>

            <div className="bottom-buttons">
                <div className="missingcardlabelinputgroup">
                        <div className="missingcardlabel">{lang ? strings.cn.song : strings.en.song} 1</div>
                        <input
                            type="text"
                            className="missingcardrounded-input"
                            placeholder={lang ? strings.cn.songname : strings.en.songname}
                            value={missingSongName1}
                            onChange={(e) => setMissingSongName1(e.target.value)}
                        />
                        </div>
                    <div className="missingcardlabelinputgroup">
                            <input
                            type="text"
                            className="missingcardrounded-input"
                            placeholder={lang ? strings.cn.singername : strings.en.singername}
                            value={missingSingerName1}
                            onChange={(e) => setMissingSingerName1(e.target.value)}
                        />
                     </div>

                <div className="missingcardlabelinputgroup" >
                        <div className="missingcardlabel">{lang ? strings.cn.song : strings.en.song} 2</div>
                        <input
                            type="text"
                            className="missingcardrounded-input"
                            placeholder={lang ? strings.cn.songname : strings.en.songname}
                            value={missingSongName2}
                            onChange={(e) => setMissingSongName2(e.target.value)}
                        />
                </div>

                
                <div className="missingcardlabelinputgroup"  >
                     <input
                        type="text"
                        className="missingcardrounded-input"
                        placeholder={lang ? strings.cn.singername : strings.en.singername}
                        value={missingSingerName2}
                        onChange={(e) => setMissingSingerName2(e.target.value)}
                    />
                </div>

                <div className="missingcardlabelinputgroup" >
                        <div className="missingcardlabel">{lang ? strings.cn.song : strings.en.song} 3</div>
                        <input
                            type="text"
                            className="missingcardrounded-input"
                            placeholder={lang ? strings.cn.songname : strings.en.songname}
                            value={missingSongName3}
                            onChange={(e) => setMissingSongName3(e.target.value)}
                        />
                </div>

                
                <div className="missingcardlabelinputgroup"  >
                    <input
                        type="text"
                        className="missingcardrounded-input"
                        placeholder={lang ? strings.cn.singername : strings.en.singername}
                        value={missingSingerName3}
                        onChange={(e) => setMissingSingerName3(e.target.value)}
                    />
                </div>



                
            </div>


            <div className="controlCardBottom">
<div className="controlCardButton"
    onClick={(e) => {
        e.preventDefault();
        handleSubmit();
    }}
    style={{
        backgroundColor: document.body.getAttribute('data-skin') === '1' ? '#e03637' : '#3751fe',
        borderRadius: "100px", // for making the button round
        color: "#ffffff", // white text color
        fontWeight: "500",
        fontSize: "18.5px",
        width: "100px", // set the width to control the size of the round button
        height: "40px", // set the height to control the size of the round button
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        marginTop: "12.5px",
    }}
>
    {lang ? strings.cn.submit : strings.en.submit}
</div>


            </div>
        </div>
    </div>


    );
}

export default SelectingMissingCard;